import { render, staticRenderFns } from "./TeachSource.vue?vue&type=template&id=583b9dc2&scoped=true"
import script from "./TeachSource.vue?vue&type=script&lang=js"
export * from "./TeachSource.vue?vue&type=script&lang=js"
import style0 from "./TeachSource.vue?vue&type=style&index=0&id=583b9dc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583b9dc2",
  null
  
)

export default component.exports